export default "__VITE_ASSET__Cy7xmEKe__"